import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnDestroy,
} from '@angular/core';
import * as _ from 'lodash';


@Component({
  template: ''
})
export class BaseDropdownComponent implements OnInit, OnDestroy {

  /**
   * Dropup variation
   * https://v4-alpha.getbootstrap.com/components/dropdowns/#dropup-variation
  */
  @Input() dropup: boolean = false;


  /**
   * Dark styled dropdown
  */
  @Input() darkStyle: boolean = false;


  /**
   * Dropdown Items
  */
  @Input() items: Array<any> = [];
  @Input() placeholder: string;


  selectedItem: any;
  @Output() selectedChange = new EventEmitter<any>();


  ngOnInit() {
    if (this.items && this.items.length) {
      // if we already have selectedItem and items contain this option - do nothing
      if (this.selectedItem && _.find(this.items, {option: this.selectedItem.option})) {
        return;
      }
      // else set new selectedItem
      const active = this.items.find(item => item.active);
      if (active) {
        this.selectedItem = active;
      } else if (!this.placeholder) {
        this.selectedItem = this.items[0];
      }
    }
  }

  ngOnDestroy() {
    this.items = [];
    this.selectedItem = null;
  }

  // handlers:
  onSelectedChange(selected: any) {
    this.selectedItem = selected;
    this.selectedChange.emit(selected);
  }
}
